'use strict';

export default class cvToFavorite {
    constructor(options) {
        this.opt = options;
        this.bindHandlers();
    }

    bindHandlers() {
        let self = this;

        // add|remove favorite vacancy
        self.opt.$switchCvFavoriteBtn.click(function () {
            let elem = $(this);
            let cvId = elem.attr('data-cv-id');

            $.post(self.opt.url, {cvId: cvId}, function (data) {
                if (data.success) {
                    elem.toggleClass('active');
                    if (elem.hasClass('active')) {
                        elem.html(self.opt.removeText);
                    } else {
                        elem.html(self.opt.addText);
                    }
                } else {
                    console.info(data.message);
                }
            })
        });

        $('#switch-cv-favorite-not-authorized').click(function () {
            let date = new Date();
            let minutes = 20;
            date.setTime(date.getTime() + (minutes * 60 * 1000));

            document.cookie = 'clicked_add_cv_to_favorite' + "=" + $(this).data('cv-id') + "; expires=" + date + "; path=/;";
        });
    }
}